import { createFileRoute } from '@tanstack/react-router'

// Leaf route — plan-root viewer with no pin selected:
// `/project/:projectId/:planId/:viewType` (viewType ∈ list | split | plan).
// PlanViewerNew is mounted by the parent _viewer/route.tsx layout; `planId`
// and `viewType` are read by the container via useParams({ strict: false }).
// The legacy positional params (tab/pinOption/page/size/search/...) live in the
// search now, validated by the inherited pinsSearchSchema.
export const Route = createFileRoute(
  '/_authenticated/project/$projectId/$planId/_viewer/$viewType/'
)({
  component: () => null
})
